export const LOG_ERROR_MESSAGE = 'app/ErrorBoundary/LOG_ERROR_MESSAGE';
export const LOG_ERROR_MESSAGE_SUCCESS =
  'app/ErrorBoundary/LOG_ERROR_MESSAGE_SUCCESS';
export const LOG_ERROR_MESSAGE_ERROR =
  'app/ErrorBoundary/LOG_ERROR_MESSAGE_ERROR';
